import React from 'react';

const CampanaHero = () => {
  return (
    <section className="campana-hero">
      <img
        src={require('../../landing-plans/public/hero-carnaval.png')}
        alt="Carnaval argentino"
        className="campana-hero__bg"
      />
      <div className="campana-hero__overlay" />

      <div className="campana-hero__content">
        <div className="campana-hero__badge">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
            <path d="M12 9v4" />
            <path d="M12 17h.01" />
          </svg>
          Cupos limitados por destino
        </div>

        <h1 className="campana-hero__title">
          Carnaval y Semana Santa se venden en pocas semanas
        </h1>

        <p className="campana-hero__subtitle">
          Algunos alojamientos se ven más. Otros quedan atrás.
        </p>

        <p className="campana-hero__description">
          Durante estas fechas la demanda explota y la competencia también. Por eso en Alohar lanzamos una campaña de
          visibilidad especial, pensada para que tu alojamiento tenga mayor exposición justo cuando los huéspedes están
          buscando.
        </p>

        <div className="campana-hero__info">
          <div className="campana-hero__info-item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
              <line x1="16" x2="16" y1="2" y2="6" />
              <line x1="8" x2="8" y1="2" y2="6" />
              <line x1="3" x2="21" y1="10" y2="10" />
            </svg>
            <span>Duración: 2 meses</span>
          </div>
          <div className="campana-hero__info-item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <circle cx="12" cy="12" r="6" />
              <circle cx="12" cy="12" r="2" />
            </svg>
            <span>Enfoque: Carnaval + Semana Santa</span>
          </div>
        </div>

        <div className="campana-hero__points">
          <p>No es una suscripción.</p>
          <p>No es permanente.</p>
          <p className="campana-hero__points--highlight">Es una oportunidad puntual.</p>
        </div>

        <a href="#planes" className="campana-hero__cta">
          Quiero participar
        </a>
      </div>
    </section>
  );
};

export default CampanaHero;
